import React, {Fragment} from 'react';
import {Button} from "../../../components/Button";
import Title from "../../../components/Title";
import Icon from "../../../components/Icon";
// import {Link} from "react-router-dom";
import {bindActionCreators} from "redux";
import {fetchCurrentUser, updateCurrentUser} from "../../../../creators/currentUser";
import connect from "react-redux/es/connect/connect";
import {PageLoader} from "../../../components/Loader";
import {config} from "../../../../config";
import Helmet from "react-helmet";
import Modal from "../../../components/Modal";
import UploaderAC from "../../../components/upload/UploadAC";
import DateSince from "../../../components/Date";
import moment from "moment-timezone";
import ModalSubscription from "../../../components/ModalSubscription";
import imgCertified from "../../../../images/photo-certification.jpg"
import DisplayImage from "../../../components/DisplayImage";

class Subscription extends React.Component {
    constructor(props){
        super(props);
        this.state= {
            uploadPhoto: false,
            subscription: false,
            toggleDisplayImage: false
        };
        this.props.fetchCurrentUser();
    }

    cancelPhoto(){
        this.props.updateCurrentUser({profile : {photoCertifiedId : ""}})
    }

    render() {
        let isAvanatage = [2,3,4].includes(this.props.currentUser.profile.gender);
        return this.props.currentUseLoading ? <PageLoader/> : (
            <Fragment>
                <div className="settings-wrapper">
                    <Helmet>
                        <title>{config.preTitle}Abonnement / Certification{config.postTitle}</title>
                    </Helmet>
                    <div className="block">
                        <Title className={"settings-title"} heading={"heading-2"} display={"display-2"}>Abonnement /
                            Certification</Title>
                        <div className="settings-sub-title">Certification</div>
                        <div className="content">
                            {this.props.currentUser.isCertified ? (
                                <span className={"is-certified"}>Vous êtes : <Icon type={"certificate"}/> <span
                                    className={"certified"}>Membre certifié</span> {this.props.currentUser.profile.photoCertified && (<img className={"img-photo"} src={`${this.props.currentUser.profile.photoCertified}?width=250`} alt={""} />)}</span>
                            ) : (

                                // this.props.currentUser.profile.gender !== 1 ? (
                                <div>
                                    {this.props.currentUser.profile.photoCertified === "" && !this.props.currentUser.isCertified && (
                                        <div id="become-certified">
                                            {isAvanatage && (
                                                <div className="alert-info"><Icon type="bulhorn"/> Vous devez certifier
                                                    votre compte pour profiter des fonctionnalités PREMIUM de Voissa.
                                                </div>)}
                                            <h3>Règles pour certifier votre compte</h3>
                                            <div className="consign">
                                                <img alt={""} src={imgCertified}
                                                     onClick={() => this.setState({toggleDisplayImage: true})}/>
                                                <div className="consign-explained">
                                                    <ul>
                                                        <li>Tenir un papier en main sur lequel est écrit <b>VOISSA et
                                                            votre
                                                            PSEUDONYME</b>.<br/> (pas de photomontage)
                                                        </li>
                                                        <li>Votre corps apparait au maximum pour prouver qui vous
                                                            êtes.<br/> (visage non obligatoire)
                                                        </li>
                                                        <li><b className={"text-danger"}>{this.props.currentUser.profile.gender === 3 ? "POUR LES COUPLES : Madame doit obligatoirement apparaitre sur le cliché " : "ATTENTION: Si la photo laisse planer un doute la certification sera refusée."}</b></li>
                                                    </ul>
                                                    <Button btnStyle={"primary-reverse"}
                                                            size={"small"}
                                                            onClick={() => this.setState({uploadPhoto: true})}
                                                            content={"Ajouter une photo pour certification"}/>
                                                </div>
                                            </div>
                                            <Modal toggle={this.state.toggleDisplayImage}
                                                   handleClose={() => this.setState({toggleDisplayImage: false})}>
                                                <DisplayImage
                                                    handleClose={() => this.setState({toggleDisplayImage: false})}
                                                    mediaAttachementArray={[{media: imgCertified}]}
                                                />
                                            </Modal>
                                            <Modal toggle={this.state.uploadPhoto}
                                                   handleClose={() => this.setState({uploadPhoto: false})}>
                                                <UploaderAC type="photo"
                                                            uploadPath={"/users/me/upload-photo"}
                                                            handleClose={() => this.setState({uploadPhoto: false})}/>
                                            </Modal>
                                        </div>
                                            )}
                                            {this.props.currentUser.profile.photoCertified !== "" && !this.props.currentUser.isCertified && (
                                                <Fragment>
                                                    <span className={"become-certified"}>Demande en attente</span>
                                                    <img className={"img-photo"} src={`${this.props.currentUser.profile.photoCertified}?width=250`} alt={""} />
                                                    <Button btnStyle={"primary-reverse"}
                                                            size={"small"}
                                                            onClick={()=>this.cancelPhoto()}
                                                            content={"Annuler"}/>
                                                </Fragment>
                                            )}
                                        </div>
                            )}
                        </div>
                        <div className="settings-sub-title">Abonnement</div>
                        <div className="content">
                            {this.props.currentUser.customer.subscribed ? (
                                    this.props.currentUser.customer.aboDateEnd && moment().isBefore(this.props.currentUser.customer.aboDateEnd) ? (
                                            <span className={"subscribed"}>Vous avez un abonnement : <span
                                                className={"subscription-type"}>Premium valable jusqu'au
                                    <DateSince
                                        date={this.props.currentUser.customer.aboDateEnd}
                                        prefix={false}
                                        currentFormat={false}
                                        className={"date-abo"}
                                    />
                                </span></span>
                                    ) : (<span className={"subscribed"}>Vous avez un abonnement : <span
                                        className={"subscription-type"}>Premium</span></span>)

                            ) : (
                                <span className={"get-subscription mb-8"}>Vous n'avez pas d'abonnement&nbsp;
                                    <Button btnStyle={"primary-reverse"}
                                            size={"small"}
                                            onClick={() => this.setState({subscription: true})}
                                            content={"Prendre votre abonnement"}/>
                                    </span>
                            )}
                        </div>
                        <Modal toggle={this.state.subscription}
                               handleClose={() => this.setState({subscription: false})}>
                            <ModalSubscription handleClose={() => this.setState({subscription: false})} />
                        </Modal>
                        {/*<div className="settings-btn-group">*/}
                        {/*    <Button size={"medium"}*/}
                        {/*            btnStyle={"primary-reverse"}*/}
                        {/*            onClick={() => this.handleSubmit()}*/}
                        {/*            content={"Enregistrer"}/>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,
    updateCurrentUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Subscription);